module.exports = __webpack_public_path__ + "static/media/55.010907f5.jpg";